import "./index.scss"

require.context("./static", false, /\.(jpg|png|svg)$/)
require.context("./static/de", false, /\.(jpg)$/)
require.context("./static/en", false, /\.(jpg)$/)
require.context("./static/intersport", false, /\.(png)$/)
